import React, { Component, useEffect, useRef } from 'react'
import { Link, Route, Switch, Redirect, useLocation, useHistory, useParams } from 'react-router-dom'
import { apiRequest } from './reducers/data'
import VideosContainer from './components/VideosContainer'
import SubmitRPEContainer from './components/SubmitRPEContainer'
import VideoDetailContainer from './components/VideoDetailContainer'
import ProfileContainer from './components/ProfileContainer'
import LeaderboardContainer from './components/LeaderboardContainer'
import NewsContainer from './components/NewsContainer'
import FeedContainer from './components/FeedContainer'
import SignInContainer from './components/SignInContainer'
import NotInStudyContainer from './components/NotInStudyContainer'
import WalkTestContainer from './components/WalkTestContainer'
import WelcomeIntroContainer from './components/WelcomeIntroContainer'
import WelcomeConnectContainer from './components/WelcomeConnectContainer'
import WelcomeNotifsContainer from './components/WelcomeNotificationsContainer'
import WelcomeCalendarContainer from './components/WelcomeCalendarContainer'
import SettingsContainer from './components/SettingsContainer'
import EulaContainer from './components/EulaContainer'
import ErrorBoundary from './components/ErrorBoundary'
import { ActionType } from './constants'
import Resource from './Resource'

import './styles/index.css'
import { createBrowserHistory } from 'history'

const onLogout = () => {
  window.location.href = window.location.href.includes('localhost')
    ? 'http://localhost:5000/logout-mobile'
    : '/logout-mobile'
}
const userAcceptedEula = (accepted_date) => {
  let accepted = new Date(accepted_date)
  let updated = new Date('2022-09-07') //TODO - make this configurable somewhere
  if (accepted < updated) {
    return true
  }
  return false
}
const Tabs = [
  {
    path: '/mobile/videos',
    label: 'Videos',
    icon: require('./images/icon_tab_videos.png'),
  },
  {
    path: '/mobile/profile',
    label: 'Profile',
    icon: require('./images/icon_tab_profile.png'),
  },
  {
    path: '/mobile/leaderboard',
    label: 'Leaderboard',
    icon: require('./images/icon_tab_leaderboard.png'),
  },
  {
    path: '/mobile/feed',
    label: 'Feed',
    icon: require('./images/icon_tab_feed.png'),
  },
  {
    path: '/mobile/news',
    label: 'News',
    icon: require('./images/icon_tab_news.png'),
  },
]

function usePrevPropValue(value) {
  const ref = React.useRef()
  React.useEffect(() => {
    ref.current = value
  })
  return ref.current
}

function AppWithUser(props) {
  const screenContainerRef = useRef(null)

  const onRecordAction = async (action, value) => {
    await props.onSaveMe({ action: action, value })
  }

  const onRecordVideoView = async (videoId) => {
    await props.onSaveMe({ action: ActionType.Watched, value: videoId })
  }

  const onUnlinkDevices = async () => {
    await props.onSaveMe({ unlinkFitnessDevices: true })
    await props.onRefreshMe()
  }

  const { pathname, me, onRefreshMe, onSaveMe } = props
  const prevPathname = usePrevPropValue(pathname)

  useEffect(() => {
    onRecordAction(ActionType.PageView, props.pathname)
  }, [])

  useEffect(() => {
    if (props.pathname !== prevPathname) {
      onRecordAction(ActionType.PageView, props.pathname)
    }
  }, [pathname])

  return (
    <main>
      <Switch>
        <Route path="/mobile/eula" render={() => <EulaContainer />} />
        <Route
          path="/mobile/welcome"
          render={(props) => (
            <div className="screen-container presented" ref={screenContainerRef}>
              <Switch>
                <Route exact path="/mobile/welcome/intro">
                  <WelcomeIntroContainer {...props} onLogout={onLogout} />
                </Route>
                <Route exact path="/mobile/welcome/connect">
                  <WelcomeConnectContainer me={me} onSave={onSaveMe} onRefresh={onRefreshMe} />
                </Route>
                <Route
                  exact
                  path="/mobile/welcome/notifications"
                  render={() => <WelcomeNotifsContainer />}
                />
                <Route
                  exact
                  path="/mobile/welcome/calendar"
                  render={() => <WelcomeCalendarContainer me={me} onSave={onSaveMe} />}
                />
                <Route render={() => <Redirect to="/mobile/welcome/intro" />} />
              </Switch>
            </div>
          )}
        />
        <Route
          default
          render={() => (
            <React.Fragment>
              {!me.completedOnboarding ? (
                <Redirect to="/mobile/welcome/intro" />
              ) : (
                <div className="screen-container" ref={screenContainerRef}>
                  {!me.eula_accepted || userAcceptedEula(me.eula_accepted) ? (
                    [<Redirect to="/mobile/eula" />, console.log(me.eula_accepted)]
                  ) : (
                    <div>
                      <Switch>
                        <Route
                          path="/mobile/videos"
                          render={() => (
                            <VideosContainer me={me} screenContainerRef={screenContainerRef} />
                          )}
                        />
                        <Route
                          path="/mobile/profile"
                          render={() => <ProfileContainer onRefreshMe={onRefreshMe} me={me} />}
                        />
                        <Route
                          exact
                          path="/mobile/leaderboard"
                          render={() => <LeaderboardContainer />}
                        />
                        <Route exact path="/mobile/news" render={() => <NewsContainer />} />
                        <Route exact path="/mobile/feed" render={() => <FeedContainer me={me} />} />
                        <Route exact path="/mobile/submit-rpe" render={() => <span />} />
                        <Route
                          exact
                          path="/mobile/mwt6"
                          render={() => <WalkTestContainer me={me} />}
                        />
                        <Route
                          path="/mobile/mwt6/:id"
                          render={(props) => (
                              <WalkTestContainer
                                walkTestId={props.match.params.id}
                                me={me}
                                screenContainerRef={screenContainerRef}
                              />
                          )}
                        />
                        <Route render={() => <Redirect to="/mobile/videos" />} />
                      </Switch>
                      <Route
                        path="/mobile/submit-rpe"
                        render={() => (
                          <div className="screen-container presented" ref={screenContainerRef}>
                            <SubmitRPEContainer />
                          </div>
                        )}
                      />
                      <Route
                        path="/mobile/videos/:id"
                        render={(props) => (
                          <div className="screen-container pushed" ref={screenContainerRef}>
                            <VideoDetailContainer
                              videoId={props.match.params.id}
                              onRecordView={onRecordVideoView}
                              screenContainerRef={screenContainerRef}
                            />
                          </div>
                        )}
                      />
                      <Route
                        exact
                        path="/mobile/profile/settings"
                        render={() => (
                          <div className="screen-container pushed" ref={screenContainerRef}>
                            <SettingsContainer
                              me={me}
                              onUnlinkDevices={onUnlinkDevices}
                              onLogout={onLogout}
                              screenContainerRef={screenContainerRef}
                            />
                          </div>
                        )}
                      />
                    </div>
                  )}
                </div>
              )}
              <div className="tab-bar">
                {Tabs.map((tab) => (
                  <Link
                    key={tab.path}
                    to={tab.path}
                    className={`tab ${pathname.startsWith(tab.path) && 'active'}`}
                  >
                    <img src={tab.icon} alt="icon" />
                    <div>{tab.label}</div>
                  </Link>
                ))}
              </div>
            </React.Fragment>
          )}
        />
      </Switch>
    </main>
  )
}

function App() {
  console.log('data env', process.env, process.env.REACT_APP_BASE_URL)
  let _bridgeSetupTimeout
  const useCurrentPath = () => {
    const location = useLocation()
    const [{ route }] = matchSwitch(routes, location)

    return route.path
  }

  const history = useHistory()

  const onBridgeReady = () => {
    console.log('BRIDGE READY')
    clearTimeout(_bridgeSetupTimeout)

    window.bridge.setNotificationTokenHandler(async (platform, value) => {
      console.warn(`calling push notification code ${platform} == ${value}`)
      await window.store.dispatch(apiRequest(['me', 'push-token'], 'POST', { platform, value }))
    })
    window.bridge.setPushReceivedHandler(async () => {
      console.log('PUSH RECIEVED HANDLER')
      // Refresh the cache of the `News` information so it's displayed immediately
      await window.store.dispatch(apiRequest(['posts']))
    })
    window.bridge.setPushActionHandler(async (elfitInfo) => {
      console.log('BRIDGE PUSH HANDLER', elfitInfo)
      if (elfitInfo === 'show-posts') {
        history.push('/mobile/news')
      }
      if (elfitInfo === 'show-feed') {
        history.push('/mobile/feed')
      }
      if (elfitInfo === 'submit-rpe') {
        history.push('/mobile/submit-rpe')
      }
      if (elfitInfo.includes('show-mwt6')) {
        //const myArray = elfitInfo.split('::')
        //history.push(`/mobile/mwt6/${myArray[1]}`)
        history.push('/mobile/news')
      }
    })
  }

  const onBridgeMissing = () => {
    alert(
      'Please review your baseline evaluation and download the EL-FIT mobile app to access videos and updates on your phone.'
    )
    history.push('/welcome/1')
  }

  useEffect(() => {
    console.log(`==== window bridge `, window.bridge)
    if (window.bridge) {
      onBridgeReady()
    } else {
      if (!window.location.href.includes('localhost')) {
        _bridgeSetupTimeout = setTimeout(onBridgeMissing, 3000)
      }
      window.addEventListener('bridge-ready', onBridgeReady)
    }
  }, [])

  const location = useLocation()

  const pathname = location.pathname

  return (
    <Resource path={['me']} placeholder={'loading'}>
      {(me, { onSave, onRefresh }) => {
        if (me === 'loading') {
          return <main className="loading">Loading...</main>
        }
        if (!me.id) {
          return (
            <main>
              <Switch>
                <Route exact path="/mobile/sign-in" component={SignInContainer} />
                <Route exact path="/mobile/not-in-study" component={NotInStudyContainer} />
                <Route render={() => <Redirect to="/mobile/sign-in" />} />
              </Switch>
            </main>
          )
        }

        return (
          <ErrorBoundary key={'error-boundary-key'}>
            <AppWithUser me={me} onSaveMe={onSave} onRefreshMe={onRefresh} pathname={pathname} />
          </ErrorBoundary>
        )
      }}
    </Resource>
  )
}

export default App
